// Main.js

//import React, { useState, useRef } from 'react';
//import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/CommonCtx';
import FixedHeader from './FixedHeader';
import FixedBottom from './FixedBottom';
import MainMenu from './MainMenu';
import LocMap from './LocMap';
import SitePics from './SitePics';
import IssueReg from './IssueReg';
import Pano360 from './Pano360';
import NotiBrd from './NotiBrd';
//import { useTheme } from "@emotion/react";
//import { styled } from '@mui/material/styles';
//import { Container, Card, Box, Typography } from '@mui/material';

const Main = (props) => {
    //console.log('main_props', props);

    //const theme = useTheme();
    //const navigate = useNavigate();
    
    //const [value, setValue] = useState('0');
    //const ref = useRef(null);

    const { mode } = useAuth();
    //console.log('main_user', user);

    //const TagName = mode;
    //const content = <TagName />;
    //console.log('tag', mode);

    let content = null;
    if (mode === 'MainMenu') {
        content = <MainMenu /> 
    } else if (mode === 'SitePics') {
        content = <SitePics />
    } else if (mode === 'IssueReg') {
        content = <IssueReg />
    } else if (mode === 'Pano360') {
        content = <Pano360 />
    } else if (mode === 'NotiBrd') {
        content = <NotiBrd />
    } else if (mode === 'LocMap') {
        content = <LocMap />
    }

    return (
        <>
            <FixedHeader />
            { content }
            <FixedBottom />
        </>
    );
};

export default Main;


